/* Size conversion — Update 2.0.
   One chart per product. Active country row and size column are black. */
(function () {
  'use strict';

  function norm(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function cellText(cell) {
    return norm(cell && cell.textContent);
  }

  function init(root) {
    if (!root || root.getAttribute('data-sg-ready') === 'true') return;
    var table = root.querySelector('table');
    if (!table) return;
    root.setAttribute('data-sg-ready', 'true');

    var allRows = [].slice.call(table.querySelectorAll('tr'));
    var header = allRows[0];
    var bodyRows = allRows.slice(1);
    if (!header || !bodyRows.length) return;

    var chart = root.getAttribute('data-sg-chart') || 'rtw';
    var preferred = norm(root.getAttribute('data-selected-size'));
    var activeCol = 1;
    var activeRow = 0;

    if (chart === 'denim') {
      [].forEach.call(header.children, function (cell, i) {
        if (i > 0 && cellText(cell) === 'AUS') activeCol = i;
      });
      bodyRows.forEach(function (tr, idx) {
        var label = cellText(tr.children[0]).replace(/[–—-]/g, '-');
        var size = preferred.replace(/[–—-]/g, '-');
        if (!size) return;
        var parts = label.split('-');
        if (label === size || parts.indexOf(size) !== -1) activeRow = idx;
      });
    } else {
      bodyRows.forEach(function (tr, idx) {
        if (cellText(tr.children[0]) === 'AUS') activeRow = idx;
      });
      [].forEach.call(header.children, function (cell, i) {
        if (i > 0 && cellText(cell) === preferred) activeCol = i;
      });
    }

    function paint() {
      [].forEach.call(header.children, function (cell, i) {
        var on = i === activeCol;
        cell.classList.toggle('is-on', on);
        cell.classList.toggle('is-off', i !== 0 && !on);
      });
      bodyRows.forEach(function (tr, r) {
        [].forEach.call(tr.children, function (cell, c) {
          var on = c === activeCol || (c === 0 && r === activeRow);
          cell.classList.toggle('is-on', on);
          cell.classList.toggle('is-off', !on);
        });
      });
    }

    table.addEventListener('click', function (e) {
      var cell = e.target.closest('td');
      if (!cell || !table.contains(cell)) return;
      e.preventDefault();
      e.stopPropagation();
      var tr = cell.parentNode;
      var r = allRows.indexOf(tr);
      var c = [].indexOf.call(tr.children, cell);
      if (r < 0 || c < 0) return;
      if (r === 0 && c === 0) return;
      if (r === 0) activeCol = c;
      else if (c === 0) activeRow = r - 1;
      else {
        activeRow = r - 1;
        activeCol = c;
      }
      paint();
    });

    paint();
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-size-conversion]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
